<template>
    <a href="javascript:;" @click.prevent="onSort()" class="sort-link">
        <oc-plugin-slot name="before-column" v-bind="col" ref="beforeColumn" />

        <span>{{col.title}}</span>
        <oc-icon :type="iconType" v-class="['pull-right', 'sort-' + type]" />

        <oc-plugin-slot name="after-column" v-bind="col" ref="afterColumn" />
    </a>
</template>

<script>
import {cloneObject} from '@utils'
import {appendQueryString} from '@/helpers/Utils'

export default {
    name: 'oc-sort-column-default',
    inject: ['$source'],
    props: ['col'],
    computed: {
        type() {
            let type = false

            if(this.$source.sortMapChangeTracker && this.$source.conditionsState.sort.has(this.col.field)) {
                type = this.$source.conditionsState.sort.get(this.col.field).type
            }

            return type
        },
        iconType() {
            return ! this.type ? 'sort' : 'sort-' + this.type
        }
    },
    methods: {
        onSort() {
            const ASC = 'asc'
            const DESC = 'desc'

            let type = this.type === ASC ? DESC : ASC

            if( false === this.$source.sortMultiple ) {
                this.$source.conditionsState.sort.clear()
            }

            this.$source.conditionsState.sort.set(this.col.field, {
                field: this.col.field,
                type
            })

            this.$source.sortMapChangeTracker++

            if( this.$source.sortUseRouter ) {
                let sortQuery = []

                this.$source.conditionsState.sort.forEach((sort) => {
                    sortQuery.push(
                        (sort.type === ASC ? '+' : '-') + sort.field
                    )
                })

                appendQueryString.bind(this)({
                    [this.$source.sortParam]: sortQuery.join(',')
                })
            }

            this.$source.$emit('on-sort', this.col.field, type)
            this.$source.$emit('change-internal', this.$source.conditionsState)
        }
    }
}
</script>

<style scoped>
    .sort-link {display:block;text-decoration:none;}
    .sort-false {color:#ddd; padding-top:3px;}
    .sort-asc {padding-top:3px;}
</style>
